import {
  PARTNER_ROUTE_PATH,
  FACILITY_ROUTE_PATH,
  FACILITY_USER_ROUTE_PATH,
  CLINICIANS_ROUTE_PATH,
  OPSSTAFF_ROUTE_PATH,
  INTAKE_ROUTE_PATH,
  CONSULTS_ROUTE_PATH,
  FACILITY_NEW_USER_ROUTE_PATH,
  NEW_FACILITY_ROUTE_PATH,
  NEW_PARTNER_ROUTE_PATH,
  NEW_INTAKE_ROUTE_PATH,
  NEW_CLINICIANS_ROUTE_PATH,
  NEW_OPSSTAFF_ROUTE_PATH,
} from '../../routers/routePaths';

import Partner from '@assets/images/sidenav/partners.svg';
import Facility from '@assets/images/sidenav/facility.svg';
import Clinicians from '@assets/images/sidenav/clinicians.svg';
import Consults from '@assets/images/sidenav/consults.svg';
import Opsstaff from '@assets/images/sidenav/opsstaff.svg';
import IntakeForm from '@assets/images/sidenav/intakeform.svg';

import PartnerColor from '@assets/images/sidenav/partners-color.svg';
import FacilityColor from '@assets/images/sidenav/facility-color.svg';
import CliniciansColor from '@assets/images/sidenav/clinicians-color.svg';
import ConsultsColor from '@assets/images/sidenav/consults-color.svg';
import OpsstaffColor from '@assets/images/sidenav/opsstaff-color.svg';
import IntakeFormColor from '@assets/images/sidenav/intakeform-color.svg';

export interface Menu {
  path: string[];
  name: string;
  icon: string;
  iconColor: string;
  subMenu?: SubMenu[];
}

interface SubMenu {
  path: string[];
  name: string;
}

export const menuConfig: Menu[] = [
  {
    path: [PARTNER_ROUTE_PATH, NEW_PARTNER_ROUTE_PATH],
    name: 'Partners',
    icon: Partner,
    iconColor: PartnerColor,
  },
  {
    path: [],
    name: 'Facilities',
    icon: Facility,
    iconColor: FacilityColor,
    subMenu: [
      {
        path: [FACILITY_ROUTE_PATH, NEW_FACILITY_ROUTE_PATH],
        name: 'Facility List',
      },
      {
        path: [FACILITY_USER_ROUTE_PATH, FACILITY_NEW_USER_ROUTE_PATH],
        name: 'Facility Users',
      },
    ],
  },
  {
    path: [INTAKE_ROUTE_PATH, NEW_INTAKE_ROUTE_PATH],
    name: 'Intake Forms',
    icon: IntakeForm,
    iconColor: IntakeFormColor,
  },
  {
    path: [CLINICIANS_ROUTE_PATH, NEW_CLINICIANS_ROUTE_PATH],
    name: 'Clinicians',
    icon: Clinicians,
    iconColor: CliniciansColor,
  },
  {
    path: [CONSULTS_ROUTE_PATH],
    name: 'Consults',
    icon: Consults,
    iconColor: ConsultsColor,
  },
  {
    path: [OPSSTAFF_ROUTE_PATH, NEW_OPSSTAFF_ROUTE_PATH],
    name: 'Ops Users',
    icon: Opsstaff,
    iconColor: OpsstaffColor,
  },
];
